const getCarsAvailableText = (inventoryCount = 0) => {
    let inventoryListingShowcase;
    if (isNaN(inventoryCount)) {
        inventoryListingShowcase = 'NaN';
    } else if (inventoryCount <= 1000) {
        inventoryListingShowcase = `${inventoryCount}`;
    } else {
        inventoryListingShowcase = '1000-plus';
    }
    const carsAvailableText = inventoryListingShowcase
        ? ` | ${inventoryListingShowcase} Cars Available`
        : '';

    return carsAvailableText;
};
export default getCarsAvailableText;
